const appSyncConfig = {
  aws_appsync_graphqlEndpoint: "https://sesnobkxqre4novqsc2k4eqb5q.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  aws_appsync_region: "ap-southeast-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "null",
};

export default appSyncConfig;
